import React from 'react';
import { TextField, FormController, FormLabel, Dropdown, MenuItem, RadioGroup, SelectionControlLabel, Radio, Typography, } from '@one-thd/sui-atomic-components';
import { MAX_OTHER_PROPERTY_TYPE_LENGTH } from '../../../constants/editDeliveryInstructions';
export var ProOrderUpForm = function (_a) {
    var securityCode = _a.securityCode, setSecurityCode = _a.setSecurityCode, lockboxLocation = _a.lockboxLocation, setLockboxLocation = _a.setLockboxLocation, lockboxCode = _a.lockboxCode, setLockboxCode = _a.setLockboxCode, preferredPackagePlacement = _a.preferredPackagePlacement, setPreferredPackagePlacement = _a.setPreferredPackagePlacement, propertyType = _a.propertyType, setPropertyType = _a.setPropertyType, siteConditions = _a.siteConditions, setSiteConditions = _a.setSiteConditions, additionalInstructions = _a.additionalInstructions, setAdditionalInstructions = _a.setAdditionalInstructions, otherPropertyType = _a.otherPropertyType, setOtherPropertyType = _a.setOtherPropertyType, deliveryType = _a.deliveryType;
    var placementLocationsList = [
        { placeName: 'Front Door', value: 'Front Door' },
        { placeName: 'Back Door', value: 'Back Door' },
        { placeName: 'Garage', value: 'Garage' },
        { placeName: 'Porch', value: 'Porch' },
        { placeName: 'Office', value: 'Office' },
        { placeName: 'Mailroom', value: 'Mailroom' },
        { placeName: 'No Preference', value: 'No Preference' },
    ];
    var propertyTypesList = [
        { typeName: 'House', value: 'House' },
        { typeName: 'Apartment', value: 'Apartment' },
        { typeName: 'Business', value: 'Business' },
        { typeName: 'Construction Site', value: 'Construction Site' },
        { typeName: 'Other', value: 'Other' },
    ];
    var STATUS_DESCRIPTION;
    (function (STATUS_DESCRIPTION) {
        STATUS_DESCRIPTION["OUTSIDE"] = "OUTSIDE";
        STATUS_DESCRIPTION["LOCKBOX"] = "LOCKBOX";
        STATUS_DESCRIPTION["THRESHOLD"] = "THRESHOLD";
    })(STATUS_DESCRIPTION || (STATUS_DESCRIPTION = {}));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sui-pb-5" },
            React.createElement(TextField, { id: "securityCode", label: "Security Code", placeholder: "Security Code is 222", optional: true, value: securityCode, onChange: function (event) {
                    setSecurityCode(event.target.value);
                }, fullWidth: true, multiline: true, maxRows: 5 })),
        deliveryType === STATUS_DESCRIPTION.LOCKBOX && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "sui-pb-5" },
                React.createElement(TextField, { id: "lockboxLocation", label: "Lockbox Location", placeholder: "Ex., front left when facing the jobsite", optional: true, value: lockboxLocation, onChange: function (event) {
                        setLockboxLocation(event.target.value);
                    }, fullWidth: true, multiline: true, maxRows: 5 })),
            React.createElement("div", { className: "sui-pb-5" },
                React.createElement(TextField, { id: "lockboxCode", label: "Lockbox Code", placeholder: "Ex., 123456", optional: true, value: lockboxCode, onChange: function (event) {
                        setLockboxCode(event.target.value);
                    }, fullWidth: true, multiline: true, maxRows: 5 })))),
        deliveryType === STATUS_DESCRIPTION.OUTSIDE && (React.createElement("div", { className: "sui-pb-5" },
            React.createElement(FormController, { fullWidth: true },
                React.createElement(FormLabel, { id: "preferredPackagePlacementLabel", optional: true }, "Preferred Package Placement"),
                React.createElement(Dropdown, { name: "preferredPackagePlacement", "aria-labelledby": "preferredPackagePlacementLabel", value: preferredPackagePlacement, onChange: function (event) {
                        return setPreferredPackagePlacement(event.target.value);
                    }, MenuProps: { placement: 'top' }, style: {
                        color: preferredPackagePlacement === '' ? '#9e9e9e' : 'inherit',
                    } },
                    React.createElement(MenuItem, { value: "", disabled: true, style: {
                            color: '#9e9e9e',
                        } }, "Select preferred placement location"),
                    placementLocationsList.map(function (placement) { return (React.createElement(MenuItem, { key: placement.value, value: placement.value }, placement.value)); }))))),
        React.createElement("div", { className: "sui-pb-5" },
            React.createElement(FormController, { fullWidth: true },
                React.createElement(FormLabel, { id: "propertyTypeLabel", optional: true }, "Property Type"),
                React.createElement(Dropdown, { id: "propertyType", "aria-labelledby": "propertyTypeLabel", value: propertyType, onChange: function (event) {
                        var value = event.target.value;
                        setPropertyType(value);
                        if (value !== 'Other' && otherPropertyType !== '') {
                            setOtherPropertyType('');
                        }
                    }, MenuProps: { placement: 'top' }, style: {
                        color: propertyType === '' ? '#9e9e9e' : 'inherit',
                    } },
                    React.createElement(MenuItem, { value: "", disabled: true, style: {
                            color: '#9e9e9e',
                        } }, "Select property type"),
                    propertyTypesList.map(function (type) { return (React.createElement(MenuItem, { key: type.value, value: type.value }, type.value)); })))),
        propertyType === 'Other' && (React.createElement("div", { className: "sui-pb-5" },
            React.createElement(TextField, { id: "otherPropertyType", label: "Other Property Type", placeholder: "If other, please specify", optional: true, value: otherPropertyType, onChange: function (event) {
                    var value = event.target.value;
                    if (value.length <= MAX_OTHER_PROPERTY_TYPE_LENGTH) {
                        setOtherPropertyType(value);
                    }
                }, fullWidth: true, multiline: true, maxRows: 5 }),
            React.createElement(Typography, { variant: "body-xs", color: "subtle", className: "sui-mt-2 sui-text-right" },
                otherPropertyType.length,
                "/",
                MAX_OTHER_PROPERTY_TYPE_LENGTH,
                ' ',
                "characters"))),
        React.createElement("div", { className: "sui-pb-5" },
            React.createElement(TextField, { id: "siteConditions", label: "Site Conditions", placeholder: "Ex., unpaved road, steep incline, short driveway, etc.", optional: true, value: siteConditions, onChange: function (event) {
                    var value = event.target.value;
                    if (value.length <= 100) {
                        setSiteConditions(value);
                    }
                }, fullWidth: true, multiline: true, maxRows: 5, minRows: 2 }),
            React.createElement(Typography, { variant: "body-xs", color: "subtle", className: "sui-mt-2 sui-text-right" },
                siteConditions.length,
                "/100 characters")),
        React.createElement("div", { className: "sui-pb-5" },
            React.createElement(FormLabel, { id: "demoRadioButtonsGroupLabel" }, "Are there stairs?"),
            React.createElement(RadioGroup, { "aria-labelledby": "demoRadioButtonsGroupLabel", name: "radio-buttons-group" },
                React.createElement(SelectionControlLabel, { value: "yes", label: "Yes" },
                    React.createElement(Radio, null)),
                React.createElement(SelectionControlLabel, { value: "no", label: "No" },
                    React.createElement(Radio, null)))),
        React.createElement("div", { className: "sui-pb-5" },
            React.createElement(FormLabel, { id: "demoRadioButtonsGroupLabel" }, "Can this location accommodate 36 foot trucks?"),
            React.createElement(RadioGroup, { "aria-labelledby": "demoRadioButtonsGroupLabel", name: "radio-buttons-group" },
                React.createElement(SelectionControlLabel, { value: "yes", label: "Yes" },
                    React.createElement(Radio, null)),
                React.createElement(SelectionControlLabel, { value: "no", label: "No" },
                    React.createElement(Radio, null)))),
        React.createElement("div", { className: "sui-pb-5" },
            React.createElement(TextField, { id: "additionalInstructions", label: "Additional Instructions", placeholder: "Add any additional detail needed.", optional: true, value: additionalInstructions, onChange: function (event) {
                    var value = event.target.value;
                    if (value.length <= 200) {
                        setAdditionalInstructions(value);
                    }
                }, fullWidth: true, multiline: true, maxRows: 5, minRows: 2 }),
            React.createElement(Typography, { variant: "body-xs", color: "subtle", className: "sui-mt-2 sui-text-right" },
                additionalInstructions.length,
                "/200 characters"))));
};
